exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-top,.menu-top-mobile,nav.menu-top,nav.menu-top-mobile{display:none!important}#content{padding:0!important}section#main{min-height:100vh!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51877112","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/onboarding/onboarding-v5.vue
// module id = yla9
// module chunks = 0